import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { Client } from '@microsoft/microsoft-graph-client';
import { AuthCodeMSALBrowserAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser';
import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';


import { Observable } from 'rxjs';
import { UserService } from '../layout/common/user/user.service';
import { OAuthSettings } from '../shared/outlook-calender/outlook-calender.module';
import { User } from './user';


@Injectable({
  providedIn: 'root'
})
export class OutLookService {
public authenticated: boolean;
  public user?: User;
  public graphClient?: Client;

  constructor(
    private msalService: MsalService,
    private userService:UserService,
    private snackBar: MatSnackBar

  ) {
    const accounts = this.msalService.instance.getAllAccounts();
    this.authenticated = accounts.length > 0;
    if (this.authenticated) {
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
    this.getUser().then((user) => {
      this.user = user;
    });
  }

  // Prompt the user to sign in and
  // grant consent to the requested permission scopes
  async signIn(): Promise<void> {
    try {
      let result:any = await lastValueFrom(
        this.msalService.loginPopup(OAuthSettings),
      );

      if (result) {
        this.msalService.instance.setActiveAccount(result.account);
        this.authenticated = true;
        this.user = await this.getUser();
        
      }
    } catch (reason: any) {
      this.snackBar.open(JSON.stringify(reason, null, 2), '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
      window.location.reload();
   
     
    }
  }

  // Sign out
  async signOut(): Promise<void> {
    await this.msalService.logout();
    this.user = undefined;
    this.graphClient = undefined;
    this.authenticated = false;
  }

  handleRedirects(): Observable<AuthenticationResult> {
    return this.msalService.handleRedirectObservable();
  }

  private async getUser(): Promise<User | undefined> {
    if (!this.authenticated) return undefined;

    // Create an authentication provider for the current user
    const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(
      this.msalService.instance as PublicClientApplication,
      {
        account: this.msalService.instance.getActiveAccount()!,
        scopes: OAuthSettings.scopes,
        interactionType: InteractionType.Popup,
      },
    );

    // Initialize the Graph client
    this.graphClient = Client.initWithMiddleware({
      authProvider: authProvider,
    });

    // Get the user from Graph (GET /me)
    const graphUser: MicrosoftGraph.User = await this.graphClient
      .api('/me')
      .select('displayName,mail,mailboxSettings,userPrincipalName')
      .get();

    const user = new User();
    user.displayName = graphUser.displayName ?? '';
    // Prefer the mail property, but fall back to userPrincipalName
    user.email = graphUser.mail ?? graphUser.userPrincipalName ?? '';
    user.timeZone = graphUser.mailboxSettings?.timeZone ?? 'UTC';

    // Use default avatar
    user.avatar = '/assets/no-profile-photo.png';

    return user;
  }
}

export function lastValueFrom<T>(observable: Observable<T>): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    let lastValue: T;
    let hasValue = false;

    const subscription = observable.subscribe({
      next: (value) => {
        lastValue = value;
        hasValue = true;
      },
      error: (err) => {
        subscription.unsubscribe();
        reject(err);
      },
      complete: () => {
        subscription.unsubscribe();
        if (hasValue) {
          resolve(lastValue!);
        } else {
          reject(new Error('No values emitted'));
        }
      }
    });
  });
}